/**
 * Участвовал ли зритель в матче — по составу игроков из записи матча (Match).
 *
 * Одно правило для клиента (кнопка «Посмотреть запись» в деталях матча) и
 * сервера (GET /api/matches/:matchId/actions): участнику открыта запись его
 * матча.
 *
 * У игрока сетевого матча есть userId аккаунта; у «явного» бота аккаунта нет,
 * только playerId. Идентификаторы сравниваются строками: на сервере userId —
 * ObjectId, а id зрителя из токена — строка. Гость (id нет) участником не
 * бывает — даже если у кого-то из игроков матча идентификаторов тоже нет.
 */
export const checkIfMatchParticipant = (match, viewerId) => {
  if (!viewerId) {
    return false;
  }
  const viewerKey = String(viewerId);
  return (match?.players || []).some((player) => {
    const playerKey = player?.userId || player?.playerId;
    return Boolean(playerKey) && String(playerKey) === viewerKey;
  });
};
